__turbopack_context__.v({
  "className": "outfit_5eddee7a-module__4BKG9a__className",
});
